import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/auth";
import { Banner } from "../../styles/pages/home/styles";
import { StaticImageData } from "next/image";
import { canBTCFlowToFoxbit } from "../../services/automatic_withdrawal";
import { isAppV2 } from "../../services/versionManager";
import { useMediaQuery } from "@mui/material";

type BannerData = {image: StaticImageData|string, link: string, backgroundColor?: string, nofill?: boolean};

const BannerAnnouncement: React.FC = () => {

    const { localCountry } = useAuth();
    const [banner, setBanner] = useState<BannerData>(null);

    const isMobileResolution = useMediaQuery('(max-width: 770px)');

    const ptBrBanner = isMobileResolution 
        ? 'https://cointimes.com.br/wp-content/uploads/2025/12/capa-Email-MRKT-1.png'
        : 'https://cointimes.com.br/wp-content/uploads/2025/12/Banner-_-Home-App-e-PC.png';

    const enUsBanner = isMobileResolution 
        ? 'https://cointimes.com.br/wp-content/uploads/2025/12/capa-Email-MRKT-1.png'
        : 'https://cointimes.com.br/wp-content/uploads/2025/12/Banner-_-Home-App-e-PC.png';

    useEffect(() => {
        const useGlobalBanner = localCountry !== 'BR';

        const banner = {
            image: useGlobalBanner ? enUsBanner : ptBrBanner,
            link: '/announcement',
            nofill: true
        };

        setBanner(banner);
    }, [localCountry]);

    if (!banner) {
        return <></>;
    }

    return (
        <>
            <Banner $backgroundColor={(banner?.backgroundColor && !banner?.nofill) ? banner.backgroundColor : banner?.nofill ? 'none' : '#000'} $nofill={banner?.nofill}>
                <a target={banner.link.startsWith('/open-in-app/') ? '_self' : '_blank'} href={banner.link} rel="noreferrer">
                    <img
                    src={typeof (banner.image) === 'string' ? banner.image : banner.image.src}
                    alt="banner"
                    />
                </a>
            </Banner>
        </>
    );
}

export default BannerAnnouncement;